/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agents_Page_Meta_DescriptionInputs */

const en_agents_page_meta_description = /** @type {(inputs: Agents_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore portfolio ideas with Glider and turn them into an account you can manage.`)
};

const de_agents_page_meta_description = /** @type {(inputs: Agents_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entdecken Sie Portfolio-Ideen mit Glider und setzen Sie sie in einem verwaltbaren Konto um.`)
};

const pt_br2_agents_page_meta_description = /** @type {(inputs: Agents_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore ideias de portfólio com o Glider e transforme-as em uma conta que você pode gerenciar.`)
};

const tr_agents_page_meta_description = /** @type {(inputs: Agents_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider ile portföy fikirlerini keşfedin ve bunları yönetebileceğiniz bir hesaba dönüştürün.`)
};

const zh_cn2_agents_page_meta_description = /** @type {(inputs: Agents_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 Glider 探索投资组合创意，并将其变成可以持续管理的账户。`)
};

const zh_hk2_agents_page_meta_description = /** @type {(inputs: Agents_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用 Glider 探索投資組合構思，並將其變成可以持續管理的帳戶。`)
};

const ko_kr2_agents_page_meta_description = /** @type {(inputs: Agents_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider로 포트폴리오 아이디어를 살펴보고 직접 관리할 수 있는 계정으로 만들어 보세요.`)
};

const ru_ru2_agents_page_meta_description = /** @type {(inputs: Agents_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изучайте идеи для портфеля с Glider и превращайте их в управляемый аккаунт.`)
};

const es_419_agents_page_meta_description = /** @type {(inputs: Agents_Page_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explora ideas de portafolio con Glider y conviértelas en una cuenta que puedas administrar.`)
};

/**
* | output |
* | --- |
* | "Explore portfolio ideas with Glider and turn them into an account you can manage." |
*
* @param {Agents_Page_Meta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const agents_page_meta_description = /** @type {((inputs?: Agents_Page_Meta_DescriptionInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agents_Page_Meta_DescriptionInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agents_page_meta_description(inputs)
	if (locale === "de") return de_agents_page_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_agents_page_meta_description(inputs)
	if (locale === "tr") return tr_agents_page_meta_description(inputs)
	if (locale === "zh-CN") return zh_cn2_agents_page_meta_description(inputs)
	if (locale === "zh-HK") return zh_hk2_agents_page_meta_description(inputs)
	if (locale === "ko-KR") return ko_kr2_agents_page_meta_description(inputs)
	if (locale === "ru-RU") return ru_ru2_agents_page_meta_description(inputs)
	return es_419_agents_page_meta_description(inputs)
});